export const sliderItems = [
    {
        id: 1,
        img: "https://ik.imagekit.io/dnddecpho/airvitamin/Air%20Vitamin_-dMqEE_hn.jpg?updatedAt=1728393364012",
        mobileImg:
            "https://ik.imagekit.io/dnddecpho/airvitamin/Air%20Vitamin_-dMqEE_hn.jpg?updatedAt=1728393364012",
        url: "https://haofa.my/location",
    },

];

export const products = [
    {
        _id: "G10",
        title: "G10",
        cnTitle: "G10",
        model: "G10",
        description: `1. Eliminates Harmful Radiation: Protects you from harmful radiation in your environment.

2. Detoxifies Your Body: Assists in discharging accumulated harmful radiation.

3. Cleanses Your Home Environment: Removes radiation brought in from outside when you return home

4. Enhances Cellular Function: Maximizes the efficiency of your body's cells.

5. Controls Microorganism Growth: Helps manage bacteria, viruses, and mites in your living space.

6. Supports Immune Health: Allows your immune system to rest and recharge for healthier tomorrow

7. Reduces Air Pollution: Purifies the air, enhancing overall well-being.

8. Long-Term Support: Guaranteed after-sales service and parts supply for 10 years.

9. Warranty: 1-year product warranty for peace of mind.

10. Energy Efficient: Safe and cost-effective, with low energy consumption (10W, 12V).`,
        cnDescription: `1. 消除有害辐射：保护您免受环境中有害辐射的侵害。

2. 身体排毒：协助排出体内积聚的有害辐射。

3. 清洁家居环境：当您回家时，清除从外面带回来的辐射

4. 增强细胞功能：最大化您身体细胞的效率。

5. 控制微生物生长：帮助管理您生活空间中的细菌、病毒和螨虫。

6. 支持免疫健康：让您的免疫系统得到休息和充电，迎接更健康的明天

7. 减少空气污染：净化空气，增强整体健康。

8. 长期支持：保证10年售后服务和零件供应。

9. 保修：1年产品保修，让您无后顾之忧。

10. 节能高效：安全且经济实惠，低能耗（10W，12V）。`,
        price: 3980,
        categories: ["all", "air-purifier"],
        color: [
            {
                name: "White",
                img: "https://ik.imagekit.io/dnddecpho/airvitamin/Air%20Vitamin_-dMqEE_hn.jpg?updatedAt=1728393364012",
            }
        ],
        inStock: true,
        label: "available",
        createdAt: new Date("2024-01-01"),
    }
];

export const serviceProducts = [
    {
        _id: "G10-6M",
        title: "6 Months & Below",
        cnTitle: "6 个月及以下",
        model: "G10-6M",
        description: "Service and repair for Air Vitamin products 6 months old and below",
        cnDescription: "6个月及以下Air Vitamin产品的维修和服务",
        price: 2,
        categories: ["service", "all"],
        color: [
            {
                name: "Service",
                img: "https://ik.imagekit.io/dnddecpho/airvitamin/Airvitamin2_parts_d__TnyAK3tdM.jpg?updatedAt=1732710696243",
            }
        ],
        inStock: true,
        label: "available",
        createdAt: new Date("2024-01-01"),
    },
    {
        _id: "G10-1Y",
        title: "1 Year & Below",
        cnTitle: "1 年及以下",
        model: "G10-1Y",
        description: "Service and repair for Air Vitamin products 1 year old and below",
        cnDescription: "1年及以下Air Vitamin产品的维修和服务",
        price: 280,
        categories: ["service", "all"],
        color: [
            {
                name: "Service",
                img: "https://ik.imagekit.io/dnddecpho/airvitamin/Airvitamin%202_parts_c__rnf5hqS8FA.jpg?updatedAt=1732710696173",
            }
        ],
        inStock: true,
        label: "available",
        createdAt: new Date("2024-01-01"),
    },
    {
        _id: "G10-MAX",
        title: "Above 1 Year",
        cnTitle: "1 年以上",
        model: "G10-MAX",
        description: "Service and repair for Air Vitamin products above 1 year old",
        cnDescription: "1年以上Air Vitamin产品的维修和服务",
        price: 380,
        categories: ["service", "all"],
        color: [
            {
                name: "Service",
                img: "https://ik.imagekit.io/dnddecpho/airvitamin/Airvitamin2_parts_b__-tMMdEa-K.jpg?updatedAt=1732710696046",
            }
        ],
        inStock: true,
        label: "available",
        createdAt: new Date("2024-01-01"),
    },
    {
        _id: "G10-BROKEN",
        title: "Broken Warranty Sticker",
        cnTitle: "损坏的保修贴纸",
        model: "G10-BROKEN",
        description: "Service and repair for Air Vitamin products with broken warranty sticker",
        cnDescription: "损坏保修贴纸的Air Vitamin产品的维修和服务",
        price: 420,
        categories: ["service", "all"],
        color: [
            {
                name: "Service",
                img: "https://ik.imagekit.io/dnddecpho/airvitamin/Airvitamin2_parts_a__M-g8cE_CgQ.jpg?updatedAt=1732710696171",
            }
        ],
        inStock: true,
        label: "available",
        createdAt: new Date("2024-01-01"),
    }
];
